import React from 'react';
import { PLANS, formatTrialEnd } from '../utils/subscription';

const TrialBanner = ({ subStatus, firmProfile, setActiveTab }) => {
  try {
    if (!subStatus || !subStatus.isTrialing) return null;
    const planName = PLANS[subStatus.plan]?.name || (subStatus.plan ? subStatus.plan.charAt(0).toUpperCase() + subStatus.plan.slice(1) : 'Trial');
    const planIcon = PLANS[subStatus.plan]?.icon || '🎁';
    const daysLeft = subStatus.daysLeft || 0;

    // Urgency color escalation
    let bgColor = 'rgba(212, 168, 83, 0.10)';
    let borderColor = 'rgba(212, 168, 83, 0.35)';
    let textColor = '#d4a853';
    if (daysLeft <= 7) {
      bgColor = 'rgba(239, 68, 68, 0.10)';
      borderColor = 'rgba(239, 68, 68, 0.35)';
      textColor = '#ef4444';
    } else if (daysLeft <= 30) {
      bgColor = 'rgba(245, 158, 11, 0.10)';
      borderColor = 'rgba(245, 158, 11, 0.35)';
      textColor = '#f59e0b';
    }

    return (
      <div style={{
        background: bgColor,
        border: `1px solid ${borderColor}`,
        borderRadius: '10px',
        padding: '0.6rem 1rem',
        margin: '0 0 1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: '0.75rem',
        fontSize: '0.85rem',
        fontFamily: "'DM Sans', sans-serif",
      }}>
        <div style={{ color: textColor, display: 'flex', alignItems: 'center', gap: '0.6rem', flexWrap: 'wrap' }}>
          <span style={{ fontSize: '1rem' }}>{planIcon}</span>
          <span><strong>Trial: {planName}</strong></span>
          <span style={{ color: '#8b8fa3' }}>·</span>
          <span style={{ color: '#a8adb7' }}>{daysLeft} {daysLeft === 1 ? 'day' : 'days'} left until {formatTrialEnd(firmProfile?.subscription?.trialEnds)}</span>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button onClick={() => setActiveTab('admin')} style={{
            padding: '0.4rem 0.9rem', borderRadius: '8px', border: `1px solid ${borderColor}`,
            background: 'transparent', color: textColor, cursor: 'pointer', fontFamily: 'inherit',
            fontSize: '0.8rem', fontWeight: 600,
          }}>Switch Tier</button>
        </div>
      </div>
    );
  } catch (e) {
    console.error('[TrialBanner] Render error (non-fatal):', e);
    return null;
  }
};

export default TrialBanner;
